import { redirect } from "react-router-dom";
import { fetchAuthSession, signOut } from "aws-amplify/auth";

// Require authentication: if not signed in, redirect to sign-in
const authMiddleware = async ({ request }: { request: Request }) => {
  try {
    const value = await fetchAuthSession();
    if (value.tokens === undefined) {
      const url = new URL(request.url);
      const redirectPath = url.pathname + url.search;
      throw redirect(`/sign-in?redirect=${encodeURIComponent(redirectPath)}`);
    }
    return null;
  } catch (error) {
    console.log(error);
    const url = new URL(request.url);
    const redirectPath = url.pathname + url.search;
    throw redirect(`/sign-in?redirect=${encodeURIComponent(redirectPath)}`);
  }
};

//Middleware to redirect user to the app if he deliberately goes to sign in
const signInMiddleware = async ({ request }: { request: Request }) => {
  const value = await fetchAuthSession();
  if (value.tokens && request.url.includes("/sign-in")) {
    throw redirect("/");
  }
};

// Guest-only middleware: if already signed in, redirect away (e.g., to update-password)
async function guestOnlyMiddleware() {
  try {
    const value = await fetchAuthSession();
    if (value.tokens !== undefined) {
      sessionStorage.setItem(
        "toastMessage",
        "You are already signed in. Use Update Password instead.",
      );
      throw redirect("/update-password");
    }
    return null;
  } catch {
    // On error fetching session, treat as guest
    return null;
  }
}

async function userSignOut() {
  try {
    await signOut();
    sessionStorage.setItem("toastMessage", "You have been signed out");
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : "Sign out failed";
    sessionStorage.setItem("toastMessage", message);
  } finally {
    // Use client-side navigation since this is called from UI, not a loader
    if (typeof window !== "undefined") {
      window.location.href = "/sign-in";
    }
  }
}

export { authMiddleware, guestOnlyMiddleware, userSignOut, signInMiddleware };
